import { render, staticRenderFns } from "./static-text-element.vue?vue&type=template&id=7324f043"
import script from "./static-text-element.vue?vue&type=script&lang=js"
export * from "./static-text-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports